import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import common from './public/locales/en/common.json'

void i18n.use(initReactI18next).init({
  lng: 'en',
  resources: { en: { common } },
  ns: ['common'],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
})

export default i18n
